import { useEffect } from 'react'

/**
 * Glide automatically refers to the div with an id "portal"
 * This hook allows to add additional classes for it
 */
export const usePortalClasses = (className?: string) => {
  useEffect(() => {
    if (!className) {
      return
    }

    const portalRoot = document.getElementById('portal')
    if (portalRoot) {
      portalRoot.classList.add(className)
    }

    return () => {
      if (portalRoot) {
        portalRoot.classList.remove(className)
      }
    }
  }, [className])
}
